export default {
  associatedBrokers: {
    bro: "get",
    url: "/user/v1/v2/banks/:code/brokers",
  },
  associateBrokers: {
    method: "patch",
    url: "/user/v1/v2/banks/:code/associate-brokers",
  },
  deleteAssociatedBrokers: {
    method: "delete",
    url: "/user/v1/v2/banks/:code/brokers/:brokerCode",
  },
};
